import Product from '@customTypes/product';
import { getDetailedDate } from '@helpers/date';
import React, { Dispatch, SetStateAction, useContext, useMemo } from 'react';
import ButtonPrimary from '@components/common/ButtonPrimary';
import HotelDetails from '@customTypes/hotel-details';
import { CartItemDetails } from '@customTypes/cart-items';
import { store } from '@context/store';
import BottomDrawerVariant from '@components/common/BottomDrawer/BottomDrawerVariant';
import { GuestGroupType } from '@customTypes/product-details';
import actionTypes from '@context/actionTypes';
import { productQuantitySelected } from '@events/DLP';
import ProductBannersFactory from './ProductBannersFactory';
import GuestGroup from './GuestGroup';

type Props = {
  cartData: CartItemDetails | undefined;
  date: Date | undefined;
  hotelDetails: HotelDetails;
  isOpen: boolean;
  product: Product;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  setTempBag: Dispatch<SetStateAction<GuestGroupType[]>>;
  tempBag: GuestGroupType[];
};

function GuestSelectorDrawer({
  cartData,
  date,
  hotelDetails,
  isOpen,
  product,
  setIsOpen,
  setTempBag,
  tempBag,
}: Props) {
  const { dispatch } = useContext(store);

  const guestsCount = useMemo(
    () => tempBag.reduce((sum: number, item: any) => sum + item.adults + item.children, 0),
    [tempBag],
  );

  const isConfirmButtonDisabled = tempBag ? !tempBag.every((group) => group.adults > 0) : false;

  const onConfirmClick = () => {
    dispatch({
      type: actionTypes.SET_GUEST_GROUPS_BAG,
      payload: tempBag,
    });

    setTempBag([]);

    setIsOpen(false);

    // Event
    productQuantitySelected(product, hotelDetails);
  };

  return (
    <BottomDrawerVariant
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      title={product.name}
      subTitle={date && getDetailedDate(new Date(date))}
    >
      <ProductBannersFactory
        cartData={cartData}
        date={date}
        hotelDetails={hotelDetails}
        product={product}
      />

      <div className="mb-40 w-full">
        {tempBag.map((group, index, { length }) => (
          <GuestGroup
            cartData={cartData}
            date={date}
            group={group}
            index={index}
            isLastItem={index + 1 !== length}
            key={group.id}
            product={product}
            setIsOpen={setIsOpen}
            tempBag={tempBag}
            setTempBag={setTempBag}
            hideHeader={false}
          />
        ))}
      </div>

      {/* FOOTER */}
      <div className="absolute backdrop-filter backdrop-blur-27px bg-white bg-opacity-84 border-rp-gray-divider border-t bottom-0 flex justify-between p-4 w-full">
        <div className="flex flex-col leading-22px text-sm">
          <p>Guests</p>

          <p className="font-rp-pn-semi-bold">
            {guestsCount > 0 ? guestsCount : <span>&#8212;</span>}
          </p>
        </div>

        <ButtonPrimary
          onClick={onConfirmClick}
          isDisabled={isConfirmButtonDisabled}
          classes="h-12 w-177px"
        >
          Confirm
        </ButtonPrimary>
      </div>
    </BottomDrawerVariant>
  );
}

export default GuestSelectorDrawer;
